import './SelectProperty.css';

import { Spinner, ListGroup } from 'react-bootstrap';
import { useState } from 'react';
import { useQuery, GET_PROPERTIES_FOR_USER } from 'utils/graphql';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import User from 'utils/user.util';

function SelectProperty({ setProperty }) {
    const { t } = useTranslation();
    const user = User.getUser();
    let navigate = useNavigate();
    const location = useLocation();
    const [properties, setProperties] = useState(null);

    const { loading: loadingProperties } = useQuery(GET_PROPERTIES_FOR_USER, {
        fetchPolicy: 'cache-first',
        variables: {
            user_sfid: user.sfid,
        },
        onCompleted: (data) => {
            setProperties(data.table.records.map((record) => record.property__c));
        },
    });

    function selectProperty(property) {
        const frenchProperties = ['CEM', 'LAU', 'PMT', 'GDA', 'PSF', 'PVM'];
        let language = 'en';
        if (frenchProperties.includes(property.external_id__c)) {
            language = 'fr';
        }
        let _property = { ...property, language };

        setProperty(_property);

        const previousPath = location.state?.from || '/contactform';
        navigate(previousPath);
    }

    return (
        <div className="select-property">
            <h2>{t('select_property')}</h2>
            {loadingProperties ? (
                <Spinner animation="border" role="status" className="m-4"></Spinner>
            ) : (
                <ListGroup className="mt-4">
                    {properties &&
                        properties.map((property, i) => (
                            <ListGroup.Item
                                action
                                variant="light"
                                key={i}
                                onClick={() => selectProperty(property)}
                            >
                                {property.name}
                            </ListGroup.Item>
                        ))}
                </ListGroup>
            )}
        </div>
    );
}

export default SelectProperty;
